<template lang="pug">
  .b-page-slug
    ._wrap
      BaseTooltipDropdown._tooltip(v-if="tooltipText" position="left" :show="true")
        ._tooltip-content(v-html="tooltipText")
      ._center
        Icon._room(name="room")
        slot
</template>

<script>
import BaseTooltipDropdown from '@/components/BaseTooltipDropdown.vue';

export default {
  name: 'PageSlug',
  components: { BaseTooltipDropdown },
  props: {
    tooltipText: String,
  },
};
</script>

<style scoped lang="scss">
.page-slug {
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;

  &__wrap {
    padding: 0 50px;
    position: relative;
  }

  &__tooltip-content {
    width: max-content;
    text-align: center;
  }

  &__center {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    border: 1px dashed #99A3C5;
    padding: 55px 160px 40px;
    border-radius: 10px;
  }

  @media (max-width: 1366px) {
    &__tooltip {
      display: none;
    }

    &__wrap {
      padding: 0;
    }
  }

  @media (max-width: 992px) {
    &__wrap {
      width: 100%;
    }

    &__center {
      width: 100%;
      box-sizing: border-box;
      padding: 55px 30px 40px;
    }

    &__room {
      max-width: 100%;// calc(100% - 30px);
    }
  }
}
</style>
